/**
 * HUB-C — KPI paiements (SumUp, Stripe, pending, preuves, retraits).
 */
import React from 'react';

export default function ActivitePaiementsKpiStrip({ kpis }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm" data-testid="activite-paiements-kpi">
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-pending"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">En attente</div>
        <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.pendingCount ?? 0}</div>
      </div>
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-sumup"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">SumUp</div>
        <div className="font-bold text-[var(--rm-white)]">{kpis?.sumupCount ?? 0}</div>
      </div>
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-stripe"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">Stripe</div>
        <div className="font-bold text-[var(--rm-white)]">{kpis?.stripeCount ?? 0}</div>
      </div>
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-proofs"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">Preuves à valider</div>
        <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.proofPendingCount ?? 0}</div>
      </div>
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-retraits"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">Retraits période</div>
        <div className="font-bold text-[var(--rm-red-light)]">{(kpis?.retraitsTotal ?? 0).toFixed(2)} €</div>
      </div>
      <div
        className="rounded-xl border p-3"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-kpi-paiements-timeline"
      >
        <div className="text-xs text-[var(--rm-gray-500)]">Timeline</div>
        <div className="font-bold text-[var(--rm-success)]">{kpis?.timelineCount ?? 0}</div>
      </div>
    </div>
  );
}
